<template>
    <div id="CheckBusiness"  v-show="visible">
        <div class="dialog">
            <div class="header">{{storeInfo.name}}</div>
            <div class="line"></div>
            <div class="body">
                <div class="warn">本店打烊啦~</div>
                <div class="content">本店营业时间:{{storeInfo.businessTimeText}},欢迎下次光临</div>
                <div class="content">您可以先浏览菜单，但无法下单!</div>
            </div>
            <div class="line"></div>
            <div class="footer">
                <button class="ok" @click="startViewOrder()">我知道了</button>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "CheckBusinessDialog",
        data() {
            return {
                visible:false,
                storeInfo:{
                    name:"",
                    businessTime:[],
                    businessTimeText:"",
                }
            }
        },
        methods:{
            startViewOrder(){
                this.visible = false;
            }
        },
        mounted(){
        }
    }
</script>

<style scoped lang="scss">
    @keyframes bounce-in {
        0% {transform: scale(0);}
        100% {transform: scale(1);}
    }
    #CheckBusiness{
        min-height: 100%;
        width: 100%;
        position: absolute;
        top: 0;
        left: 0;
        z-index:999;
        display: flex;
        justify-content: center;
        align-items: center;
        overflow: hidden;
        background: rgba(0,0,0,.3);
        .amint{animation: bounce-in .2s;}
        .dialog{
            border-radius: 10px;
            background-color: #fff;
            width: 90%;
            font-size: 16px;
            .header{
                text-align: center;
                margin-bottom: 0;
                box-shadow: none;
                border-radius: 0;
                color: #333;
                padding:10px 10px 5px 10px;
                font-weight: 700;
            }
            .body{
                padding: 10px;
                text-align: center;
                .warn{
                    font-size: 1.1rem;
                    color: #FF0000;
                    padding: 5px 0;
                }
                .content{
                    padding: 2px;
                    font-size: 0.8rem;
                    color: #B8B8B8;
                }
            }
            .footer{
                padding: 10px;
                text-align: center;
                button{
                    color: #fff;
                    width: 100%;
                    margin: auto;
                    padding: 12px;
                    border: none;
                    border-radius: 5px;
                    background-color: #BF9E61;
                }
            }
        }
        .line{
            background-image: url('../../assets/image/fengeLine.svg');
            background-size: 15px;
            background-repeat: repeat-x;
            background-position: 0 100%;
            height: 8px;
            width: 100%;
        }

    }
</style>


// WEBPACK FOOTER //
// src/components/takeoutDialog/checkBusinessDialog.vue